export default __webpack_public_path__ + "static/media/over-axle-weight.e50eba3f.svg";